Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeScriptDocument = void 0;
function isTypeScriptDocument(uri) {
    return uri.endsWith('.ts') || uri.endsWith('.tsx');
}
exports.isTypeScriptDocument = isTypeScriptDocument;
//# sourceMappingURL=shared.js.map